import React, { useEffect, useState } from 'react';
// @ts-ignore
import './progress-bar.scss';

interface ICountDetails {
    totalCount: number;
    completedCount: number;
    earnableCE: number;
    showCountDetails: boolean;
}

const ProgressBar = ({
    totalCount,
    completedCount,
    earnableCE,
    showCountDetails,
}: ICountDetails) => {
    const className = 'progress-bar';
    const [width, setWidth] = useState(0);
    useEffect(() => {
        setTimeout(() => {
            const widthPercentage = (completedCount / totalCount) * 100;
            setWidth(widthPercentage);
        }, 500);
    }, []);

    const renderCountDetails = () => (
        <div className={`${className}__count-details`}>
            <div>{`${completedCount} Completed`}</div>
            <div>{`${totalCount - completedCount} Remaining`}</div>
        </div>
    );

    return (
        <>
            <div className={className}>
                <div>
                    <p>
                        {`${totalCount} ${totalCount === 1 ? 'item' : 'items'}`}
                    </p>
                    <text>{'Total earnable CE/NCPDs: '}</text>

                    <text>
                        {`${earnableCE} ${earnableCE === 1 ? 'hour' : 'hours'}`}
                    </text>
                </div>
                <div className={`${className}__outer-wrapper`} />
                <div
                    className={`${className}__inner-progress`}
                    style={{ width: `${width}%` }}
                />
            </div>
            {showCountDetails && renderCountDetails()}
        </>
    );
};

export default ProgressBar;
